import React, { SFC } from 'react'
import Provider from '../../../../types/Provider'
import countyData from '../../../../data/county'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.css'

type Props = {
  provider: Array<Provider>
  onSelectFacility: (event:any, provider: Provider) => void
}

const FacilityRow: SFC<Props> = (props) => {
  const { provider, onSelectFacility } = props

  var county: any;

  county = ['','']

  county = countyData.find(o => o[0] === provider[0].county_id);

  return (
    <div className="facilityRow">
      <div className="facilityRowContainer">
        <div className="facilityRowTextContainer">
        <FontAwesomeIcon icon={['far', 'hospital']} size="3x" className="facilityRowIcon" />
        <div className="facilityRowText">
          <span className="facilityRowName" onClick={(event: any)=>{onSelectFacility(event, provider[0])}}>{provider[0].provider_name}</span>
          <div className="facilityRowData">
            <div>Tax ID: <span className="facilityRowBold">{provider[0].tax_id_number}</span></div>
            <div className="facilityRowItem">|</div>
            <div className="facilityRowItem">
              Status:
              {
                provider[0].status === 'Active'
                  ? (<span style={{ display: 'inline-block', marginLeft: 5, backgroundColor: 'green', color: 'white', width: 100, textAlign: 'center' }}>ACTIVE</span>)
                  : (provider[0].status === 'Pending' 
                  ? (<span style={{ display: 'inline-block', marginLeft: 5, backgroundColor: 'rgb(241, 194, 50)', color: 'white', width: 100, textAlign: 'center' }}>PENDING</span>) 
                  : (<span style={{ display: 'inline-block', marginLeft: 5, backgroundColor: 'red', color: 'white', width: 100, textAlign: 'center' }}>{provider[0].status !== undefined ? provider[0].status.toUpperCase() : ''}</span>))
              }
            </div>
            <div className="facilityRowItem">|</div>
            <div className="facilityRowItem">Address: <span className="facilityRowBold">{provider[0].address_1}</span></div>
            <div className="facilityRowItem">|</div>
            <div className="facilityRowItem">City: <span className="facilityRowBold">{provider[0].city}</span></div>
            <div className="facilityRowItem">|</div>
            <div className="facilityRowItem">County: <span className="facilityRowBold">{county!==undefined?county[1]:''}</span></div>
            <div className="facilityRowItem">|</div>
            <div className="facilityRowItem">State: <span className="facilityRowBold">{provider[0].state}</span></div>
            <div className="facilityRowItem">|</div>
            <div className="facilityRowItem">Zip: <span className="facilityRowBold">{provider[0].zip_code}</span></div>
          </div>
        </div>
      </div>
      <div className="facilityRowEditContainer" onClick={(event: any)=>{onSelectFacility(event, provider[0])}}>
        <span className="facilityRowEditButton">View Facility Profile</span>
        <FontAwesomeIcon
          icon={['fas', 'chevron-circle-right']}
          size="lg"
          className="facilityRowEditIcon"
        />
      </div>
      </div>
    </div>
  )
}
export default FacilityRow
